import { createSpacing, createBreakpoints, alpha } from '@mui/system';
import { TOKENS_LIGHT } from './theme/tokens/tokens.js';

const shouldNotForwardProps = prop => {
  return !['marginTop', 'marginLeft', 'marginRight', 'marginBottom', 'internalVariant', 'textAlign', 'm', 'mr', 'mt', 'fullHeight', 'fullWidth', 'ml', 'mb', 'margin', 'marginX', 'marginY', 'mx', 'my', 'hasHover', 'iconOnly', 'bgHeadCell', 'iconPosition'].includes(prop);
};
const spacing = createSpacing(4);
const breakpoints = createBreakpoints({});
const shape = value => {
  const shapes = {
    noRounding: '0',
    extraSmall: '4px',
    small: '8px',
    medium: '12px',
    large: '16px',
    extraLarge: '28px',
    full: '50%'
  };
  return shapes[value];
};
const elevation = value => {
  const elevations = {
    extraSmall: '2px 4px 0',
    small: '2px 8px 0',
    medium: '8px 16px 0',
    large: '16px 24px 0',
    extraLarge: '24px 32px 0'
  };
  if (value === 'flat') {
    return '';
  }
  return `${elevations[value]} ${alpha(TOKENS_LIGHT.onBackground, 0.16)}`;
};
const palette = token => props => {
  return props['theme']['palette'][token].main;
};
const _palette = props => token => {
  return props['theme']['palette'][token].main;
};
function withUtility(fn) {
  return props => {
    const isLight = props['theme']['palette'].mode === 'light';
    return fn({
      palette: _palette(props),
      isLight
    }, props);
  };
}

export { _palette, breakpoints, elevation, palette, shape, shouldNotForwardProps, spacing, withUtility };
